import { render } from "./Gifts.vue?vue&type=template&id=60bc087f&scoped=true"
import script from "./Gifts.vue?vue&type=script&lang=js"
export * from "./Gifts.vue?vue&type=script&lang=js"

import "./Gifts.vue?vue&type=style&index=0&id=60bc087f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60bc087f"]])

export default __exports__